import { getHours, getMinutes } from 'date-fns'
import { t } from 'i18next'

// @ts-ignore
import { MAX_IMAGE_SIZE_MB } from '../web/components/shared/modal-upload-photo/modal-upload-photo.constants'
import { getDay } from '../web/components/shared/weekday-start-and-end-time/weekday-start-and-end-time.constants'
import { PATTERNS, rules } from '../utils/validations.util'

export const RULES = {
  minLength: rules.minLength(1),
  maxLength: rules.maxLength(50),
  required: rules.required,
  pattern: rules.pattern(PATTERNS.ALPHANUMERIC_ONLY),
}

export const PHONE_RULE = {
  validate: rules.isValidPhoneNumber,
}
export const hasDaysSelectedRules = (hasCustomHours: boolean, selectedWeekdays: string[]) => ({
  validate: rules.hasDaysSelected(hasCustomHours, selectedWeekdays),
})

export const validateTime = ({
  value,
  day,
  hasCustomHours,
  singleHour,
  customHours,
  isStartTime,
  isEndTime,
  defaultHour,
}: {
  value: Date | string
  day: string
  hasCustomHours: boolean
  singleHour: any
  customHours: any
  isStartTime: boolean
  isEndTime: boolean
  defaultHour: Date | string
}) => {
  // In custom hours mode, skip validation if this day doesn't have hours set
  if (hasCustomHours) {
    const dayHours = customHours?.[getDay(day)]
    if (!dayHours || (!dayHours.startTime && !dayHours.endTime)) {
      return true // No hours set for this day = valid (optional)
    }
  }

  // Validate that the current value is a valid Date
  const currentValue = new Date(value)
  if (isNaN(currentValue.getTime())) {
    return isStartTime ? t('errors:forms.invalidStartTime') : t('errors:forms.invalidEndTime')
  }

  const endTime = hasCustomHours
    ? new Date(customHours?.[getDay(day)]?.endTime ?? defaultHour)
    : new Date(singleHour?.endTime ?? defaultHour)

  const startTime = hasCustomHours
    ? new Date(customHours?.[getDay(day)]?.startTime ?? defaultHour)
    : new Date(singleHour?.startTime ?? defaultHour)

  // Validate that start and end times are valid Dates
  if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
    return true // Skip comparison if either time is invalid (will be caught by format validation)
  }

  const startTimeHour = getHours(new Date(isEndTime ? startTime : value))
  const startTimeMinutes = getMinutes(new Date(isEndTime ? startTime : value))

  const endTimeHour = getHours(new Date(isStartTime ? endTime : value))
  const endTimeMinutes = getMinutes(new Date(isStartTime ? endTime : value))

  const isBothSameMeridiem =
    (startTimeHour <= 12 && endTimeHour <= 12) || (startTimeHour >= 12 && endTimeHour >= 12)

  if (isBothSameMeridiem) {
    if (startTimeHour > endTimeHour) {
      return isStartTime ? t('errors:forms.endTimeBeforeStartTime') : ''
    }
    if (startTimeHour === endTimeHour) {
      if (startTimeMinutes > endTimeMinutes) {
        return isStartTime ? t('errors:forms.endTimeBeforeStartTime') : ''
      } else if (startTimeMinutes === endTimeMinutes) {
        return isStartTime ? t('errors:forms.endTimeEqualStartTime') : ''
      }
    }
  } else {
    if (startTimeHour > endTimeHour) {
      return isStartTime ? t('errors:forms.endTimeBeforeStartTime') : ''
    }
  }
  return true
}

export const MEGABYTES_IN_BYTES = 1024 * 1024

export const PHOTO_CLIENT_RULES = (allowedTypes: string[]) => {
  return {
    required: rules.required,
    validate: {
      maxSize: rules.maxSize(MAX_IMAGE_SIZE_MB * MEGABYTES_IN_BYTES),
      acceptedFormats: rules.acceptedFormats(allowedTypes),
    },
  }
}
